import { useLocalization } from "@shared-ui/localization-context";
import * as React from "react";
import { UitkText } from "uitk-react-text";
import { UitkLink } from "uitk-react-link";

interface PriceLockupGetRatesProps {
  className: string;
  hotelLink: string;
}

export const PriceLockupGetRates = ({ className, hotelLink }: PriceLockupGetRatesProps) => {
  const { formatText } = useLocalization();

  return (
    <UitkText size={300} weight="regular" className={className}>
      <UitkLink className="getRatesText">
        <a href={hotelLink}>{formatText("hotels.price.getRates")}</a>
      </UitkLink>
    </UitkText>
  );
};

export default PriceLockupGetRates;
